export default "__VITE_ASSET__BV3hPbWv__"